import React from "react";
import { SegmentedItem } from "../../../../Components/Items";

/**
 * Filtro de fase deslizable para celular.
 */
const ChipsFase = ({ opciones, valor, onChange }) => (
    <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
        <SegmentedItem options={opciones} value={valor} onChange={onChange} style={{ width: "max-content" }} />
    </div>
);

export default ChipsFase;
